import cx from 'classnames';
import {
    AnchorHTMLAttributes,
    forwardRef,
    FunctionComponent,
    PropsWithChildren,
    SVGAttributes,
} from 'react';

import style from './MenuItem.module.css';

type Props = PropsWithChildren<
    AnchorHTMLAttributes<HTMLAnchorElement> & {
        Icon?: FunctionComponent<SVGAttributes<SVGElement>>;
        inline?: boolean;
        size?: 'small' | 'medium';
        hasFeatureDiscoveryNotification?: boolean;
    }
>;

export const MenuItem = forwardRef<HTMLAnchorElement, Props>(
    (
        {
            children,
            Icon,
            inline,
            size = 'medium',
            hasFeatureDiscoveryNotification,
            ...anchorProps
        },
        forwardedRef,
    ) => {
        return (
            <a
                {...anchorProps}
                className={cx(anchorProps.className, style.link, 'font-xs-regular', {
                    [style.inline]: inline,
                    [style.small]: size === 'small',
                    [style.medium]: size === 'medium',
                })}
                ref={forwardedRef}
            >
                {Icon ? (
                    <div
                        className={cx(style.iconContainer, {
                            [style.hasFeatureDiscoveryNotification]:
                                hasFeatureDiscoveryNotification,
                        })}
                    >
                        <Icon className={style.icon} />
                    </div>
                ) : null}
                <div className={style.text}>{children}</div>
            </a>
        );
    },
);
